import { Link, useNavigate } from 'react-router-dom'
import { useGetQuery } from 'hooks'
import { Card, Icon, PaginateTable, Row } from 'components'
import { useState } from 'react'

export const AdminQuests = () => {
  const [page, setPage] = useState({ page: 1, limit: 25 })
  const navigate = useNavigate()
  const offset = (page.page - 1) * page.limit

  const { data, isFetching } = useGetQuery({
    url: `/admin/quests?limit=${page.limit}&offset=${offset}`,
  })

  const quests = data?.quests ?? []
  const count = quests.length

  return (
    <Card>
      <Row>
        <PaginateTable
          data={quests}
          count={count}
          loading={isFetching}
          columns={[
            { title: 'Name', key: 'name' },
            { title: 'Description', key: 'description', render: (d) => d ? `${d.slice(0, 60)}${d.length > 60 ? '…' : ''}` : '—' },
            { title: 'Steps', key: 'steps', render: (s) => s?.length ?? 0 },
            {
              title: 'Award',
              key: 'award',
              render: (a) => [a?.xp ? `${a.xp} XP` : null, a?.gold ? `${a.gold}g` : null].filter(Boolean).join(' / ') || '—',
            },
            {
              title: '',
              key: 'id',
              className: 'right',
              render: () => (
                <Link to="/games/dungeon/quests">
                  <Icon icon="pencil" />
                </Link>
              ),
            },
          ]}
          addItem={() => navigate('/games/dungeon/quests')}
          onPageChange={setPage}
        />
      </Row>
    </Card>
  )
}
